import $ from 'jquery';

export default () => {
    window.setLoading = (show) => {
        var $body = $('body');

        if (show) {
            $body.addClass('loading-layer')
        } else {
            $body.addClass('showing');
           
            setTimeout(function () {
                $body.removeClass('loading-layer')
                var loadingEnded = new Event('loading-ended');
                document.dispatchEvent(loadingEnded);
                if ($body.attr('class').indexOf('template-portfolio') != -1) {
                    var loadingEndedPortfolio = new Event('loading-portfolio-ended');
                    document.dispatchEvent(loadingEndedPortfolio);
                }
            }, 200);
        }
    }
}


// WEBPACK FOOTER //
// ../views/partials/loading/loading.js